module.exports = __webpack_public_path__ + "static/media/flower3.e33254f3.png";